import type { ReactNode } from 'react'
import { Navigate, useSearchParams } from 'react-router'
import { useGetSessionQuery } from '@/entities/session'
import { safeReturnTo } from '@/shared/lib'

/**
 * Экраны до входа: вход и заявка на доступ. Живой сеанс сюда не пускает — ведёт туда,
 * откуда пришли, или в кабинет. Пока `/auth/me` едет, экран уже показан: сеанса чаще всего
 * нет, и заставка перед формой входа только мешала бы.
 *
 * После успешного входа кеш сбрасывается, запрос сеанса повторяется сам, и этот же компонент
 * уводит пользователя дальше — форма входа навигацией не занимается.
 */
export function GuestOnly({ children }: { children: ReactNode }) {
  const { data } = useGetSessionQuery()
  const [params] = useSearchParams()

  if (data !== undefined) return <Navigate to={safeReturnTo(params.get('from'))} replace />
  return children
}
